import { round } from "@components/config/helpers";
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import { Fragment } from "react";

const StrongTag = ({children}) =>  <Typography className='default-grey' component="strong" variant="strong">{children}</Typography>

const RenderDimensionString = ({diameter, width, depth, height}) => {
    const countKey = 'measurement_value';
    const widthValue = width?.[countKey];
    const depthValue = depth?.[countKey];
    const heightValue = height?.[countKey];
    const diameterValue = diameter?.[countKey];
    let jsx = [];
    if(diameterValue != null){
        jsx.push(
            <>
                <StrongTag>D</StrongTag>{round(diameterValue)}{widthValue != null || depthValue != null || heightValue != null ? ' x ' : null}
            </>
        )
    }

    if(widthValue != null){
        jsx.push(
            <>
                <StrongTag>W</StrongTag>{round(widthValue)}{depthValue != null || heightValue != null ? ' x ' : null}
            </>
        )
    }

    if(depthValue != null){
        jsx.push(
            <>
                <StrongTag>D</StrongTag>{round(depthValue)}{heightValue != null ? ' x ' : null}
            </>

        )
    }

    if(heightValue != null){
        jsx.push(
            <>
                <StrongTag>H</StrongTag>{round(heightValue)}
            </>
        )
    }

    return (
        <>
            {jsx.map((el, idx) => <Fragment key={idx} >{el}</Fragment>)}
        </>
    )

}

const ProductCardHeader = (props) => {
    const {
        diameter,
        width,
        depth,
        height,
        weight
    } = props;

    const weightStr = weight != null ? ` | ${weight}kg` : '';

    return (
        <Box className="d-flex justify-space-between pb-1 pt-1 mb-3">
            <Typography className="fs-16 pt-2">
                <StrongTag>
                    Dimensions: &nbsp;
                </StrongTag>
                <Typography className="fs-16" component="span" variant="span">
                    {/* W420 x D450 x 8860 */}
                    <RenderDimensionString
                        diameter={diameter} 
                        width={width}
                        depth={depth}
                        height={height}
                    />{weightStr}
                    {/* <StrongTag>W</StrongTag>{round(width.measurement_value)} x  <StrongTag>D</StrongTag>{round(depth.measurement_value)} x  <StrongTag>H</StrongTag>{round(height.measurement_value)}{height.unit}{weightStr} */}
                </Typography>
            </Typography>
        </Box>
    )
}

export default ProductCardHeader